
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import VueHtml2pdf from 'vue-html2pdf'
import cabecalhoPng from '../../../../../../static/img/survey/cabecalho_qma_pdf.svg'
import smfoto from '../../../../../../static/img/survey/sem-foto.png'

export default {
  name: 'tableInqueryQmaPivs',
  mixins: [ActionsForm],
  components: {VueHtml2pdf},
  props: ['qma', 'propPdf', 'selectedQma', 'dataGeracao'],
  data () {
    return {
      semImg: smfoto,
      dataFormatada: null,
      dataRelatorio: null,
      imagensData: {},
      equipamentos: [],
      atividadeCritiaca: [],
      qmaData: {},
      status: {
        Mensagem: '',
        Cor: '',
        CorTexto: ''
      }
    }
  },
  watch: {
  },

  computed: {
    nomeArquivo () {
      return `VISTORIA`
    }
  },
  mounted () {
    this.$nextTick(async () => {
      await this.generatePDF()
    })
  },
  methods: {
    dividirEmGrupos (array, tamanho) {
      let grupos = []
      for (let i = 0; i < array.length; i += tamanho) {
        grupos.push(array.slice(i, i + tamanho))
      }
      return grupos
    },
    async onLoad (value, atividade, imgs, equi) {
      this.qmaData = value
      this.atividadeCritiaca = atividade
      this.equipamentos = equi
      this.imagensData = imgs
      this.formatStatusVistoria(this.qmaData.statusvistoria)
      await this.generatePDF()
    },
    formatStatusVistoria (value) {
      if (value === 0) {
        this.status.Mensagem = 'NÃO ENVIADO'
        this.status.Cor = 'rgb(192, 192, 192)'
        this.status.CorTexto = 'rgb(106, 106, 106)'
      }
      if (value === 1) {
        this.status.Mensagem = 'AG. APROVAÇÃO'
        this.status.Cor = 'rgb(212, 238, 253)'
        this.status.CorTexto = 'rgb(0, 55, 137)'
      }
      if (value === 2) {
        this.status.Mensagem = 'AG. CORREÇÃO'
        this.status.Cor = '#ffeadc'
        this.status.CorTexto = 'rgb(255 96 0 / 92%)'
      }
      if (value === 3) {
        this.status.Mensagem = 'APROVADO'
        this.status.Cor = '#cbe9cf'
        this.status.CorTexto = 'rgb(19, 59, 26)'
      }
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement('img')
      img.src = imgHref
      img.style.border = 'none'
      return img
    },
    async generatePDF () {
      await this.$refs.html2Pdf.generatePdf()
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(cabecalhoPng, window.location.origin)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      options.margin = [2.4, 0, 0.5, 0]
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          pdf.addFileToVFS('Poppins-Bold.ttf')
          pdf.addFont('Poppins-Bold.ttf', 'Poppins', 'bold', 'WinAnsiEncoding')
          pdf.setFont('Poppins', 'bold')
          const totalPages = pdf.internal.getNumberOfPages()
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i)

            // Header Section
            pdf.addImage(headerPdf, 'PNG', 0, 0, 8.5, 0)
            pdf.setTextColor('#333333')
            pdf.setFontSize(15)
            pdf.setFont('helvetica', 'bold')
            pdf.text('RELATÓRIO DE SAÚDE E SEGURANÇA DO TRABALHO EM OBRA', 0.8, 1.5)

            // Title Section with Poppins font
            pdf.setFillColor('#F4F4F4')
            const rectWidth = pdf.internal.pageSize.getWidth() - 0.6
            pdf.roundedRect(0.35, 1.75, rectWidth, 0.5, 0.1, 0.1, 'F')
            pdf.setTextColor('#666666')
            pdf.setFontSize(10)
            pdf.text('Cliente: ' + this.qmaData.responsavelNome, 0.5, 2.05)
            pdf.text('N° do Contrato: ' + this.qmaData.numeroContrato, 6, 2.05)
            // pdf.text('Data da Vistoria: ' + this.qmaData.dataVistoriaFormatadaNotHour, 5, 2.05)

            // Footer Section
            pdf.setFillColor(28, 98, 40)
            pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.3, pdf.internal.pageSize.getWidth(), 10, 'F')
            pdf.setTextColor('#fff')
            pdf.setFontSize(10)
            pdf.text('SST - Relatório Saúde e Segurança do Trabalho em Obra', 0.5, pdf.internal.pageSize.getHeight() - 0.1)
            pdf.text(`Pág ${i} de ${totalPages}`, 7, pdf.internal.pageSize.getHeight() - 0.1)
          }
        })
        .save()
      loading.pop()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/components/pdfSurvey/pdfSurvey.js